// extracted by mini-css-extract-plugin
export default {"toc":"toc_toc__xNzR3","scroll":"toc_scroll__9Nbfc"};